'use client';
import type { PointerEvent as ReactPointerEvent } from 'react';
import type { GridCarView } from '../lib/types';
import { TRAP_COUNT } from '../lib/types';

// "The Lot" — the 12-card deal. Cards vanish while parked on the board;
// tap to pick up (card-first flow) or drag straight onto a slot.

export function GridLot({
  cars,
  placedIds,
  selectedId,
  liftId,
  cardDragProps,
}: {
  cars: GridCarView[];
  placedIds: Set<string>;
  selectedId: string | null;
  liftId: string | null;
  cardDragProps: (carId: string) => {
    onPointerDown: (e: ReactPointerEvent) => void;
    onPointerMove: (e: ReactPointerEvent) => void;
    onPointerUp: (e: ReactPointerEvent) => void;
    onPointerCancel: (e: ReactPointerEvent) => void;
  };
}) {
  const left = cars.length - placedIds.size;
  return (
    <div>
      <div className="gp-lot-head">
        <span className="gp-t">The Lot</span>
        <span className="gp-c">
          {left} car{left === 1 ? '' : 's'} · {TRAP_COUNT} traps
        </span>
      </div>
      <div className="gp-cards">
        {cars.map((car) => (
          <div
            key={car.id}
            className={[
              'gp-card',
              placedIds.has(car.id) ? 'gone' : '',
              selectedId === car.id ? 'sel' : '',
              liftId === car.id ? 'lift' : '',
            ]
              .filter(Boolean)
              .join(' ')}
            {...cardDragProps(car.id)}
          >
            <div className="gp-nm">{car.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
